import { SortIndicatorInterface } from "./SortIndicator.types";

const active = "red";
const inactive = "lightgray";

const SortIndicator = ({ sortOrder }: SortIndicatorInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_32_7952)">
      <path
        d="M18.0812 8.90859L12.5031 3.33047C12.0625 2.88984 11.35 2.88984 10.914 3.33047L5.3312 8.90859C4.62339 9.61641 5.12495 10.8305 6.12808 10.8305H17.2843C18.2875 10.8305 18.789 9.61641 18.0812 8.90859Z"
        fill={sortOrder === "sort-asc" ? active : inactive}
      />
      <path
        d="M6.12808 13.8305H17.2843C18.2875 13.8305 18.789 15.0445 18.0812 15.7523L12.5031 21.3305C12.0625 21.7711 11.35 21.7711 10.914 21.3305L5.3312 15.7523C4.62339 15.0445 5.12495 13.8305 6.12808 13.8305Z"
        fill={sortOrder === "sort-desc" ? active : inactive}
      />
    </g>
    <defs>
      <clipPath id="clip0_32_7952">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SortIndicator;
